export const PORTAL_TITLE = "Capital One Travel Portal";
export const VACATION_RENTAL_CHECKOUT_TITLE =
  "Complete Vacation Rental Booking";
